import * as React from 'react';
import { ChiamaAPI, Trad } from '../components/';
import { NavLink } from 'react-router-dom';
import * as Dati from '../Dati';
import { BasePureComponent } from './BaseComponent';


interface IContestoProps extends Dati.IBaseProps {
    Info: Dati.InfoContesto[]; //Array dei dati
}

export class Contesto extends BasePureComponent<IContestoProps> {
    constructor(props: any) {
        super(props);
        this.OnErrore = this.OnErrore.bind(this);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIListaContesto, datiNuovi: boolean): React.ReactNode {
        let Valori: any = [];
        let y: number = 0;
        if (dati.Dati != undefined) {
            for (let i: number = 0; i < dati.Dati.length; i++) {
                let valore: string = "";
                if (dati.Dati[i].ParametroTrad == "")
                    valore = dati.Dati[i].Valore;
                else
                    valore = Trad.TradParam(dati.Dati[i].ParametroTrad, [dati.Dati[i].Valore]);

                Valori.push(<div className="col-lg-4" key={i}>
                    <label>{Trad.Trad(dati.Dati[i].Etichetta)}</label>
                    <input className="form-control kt-input kt-input--solid" value={valore} type="text" readOnly onChange={(e) => this.OnChange(e)} />
                </div>);
            }
        }
        return Valori;
    }

    private SplittaOggetti(obj: any[]) {
        let objNew: any[] = [];
        for (let i: number = 0; i < obj.length; i++) {
            objNew.push(< div className="col-lg-4" key={i} > {obj[i]}</div>);
        }
        return objNew;
    }

    private SePrimoLink(i: number): string {
        if (i == 1)
            return " active show";
        else
            return "";
    }

    private SePrimoDiv(i: number): string {
        if (i == 1)
            return " active";
        else
            return "";
    }

    public render() {

        let titoliTab: any = [];


        let x: number = 1;
        for (let I of this.props.Info) {
            titoliTab.push(<li className="nav-item" key={x}><a className={"nav-link" + this.SePrimoLink(x)} data-toggle="tab" href={"#kt_tabs_1_" + x}>{I.Nome}</a></li>);
            x++;
        }

        x = 1;
        let contenuto: any = [];
        for (let I of this.props.Info) {

            let URL: JSX.Element;
            if (I.urlRitorno == "#" || I.urlRitorno == "") {
                URL = <div></div>;
            }
            else {
                URL = <NavLink to={I.urlRitorno} className="btn btn-outline-brand kt-btn kt-btn--icon">
                    <span><i className="fa fa-chevron-right"></i><span>{Trad.Trad("Visualizza")}</span></span>
                </NavLink>;
            }

            if (I.urlAPI != "") {
                contenuto.push(<div className={"tab-pane" + this.SePrimoDiv(x)} id={"kt_tabs_1_" + x} role="tabpanel" key={x}>
                    <div className="form-group kt-form login-form__group row">
                        <ChiamaAPI URL={I.urlAPI} Aggiornare={1} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={(s, e) => this.OnErrore(s, e)} />
                    </div>
                    {URL}
                </div>
                )
            }
            else {
                contenuto.push(<div className={"tab-pane" + this.SePrimoDiv(x)} id={"kt_tabs_1_" + x} role="tabpanel" key={x}>
                    <div className="form-group kt-form login-form__group row">
                        {this.SplittaOggetti(I.Dati)}
                    </div>{URL}
                </div>
                )
            }
            x++;
        }
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Information")}
                        </h3>
                    </div>
                </div>
            </div>
            <div className="kt-portlet__body">
                <ul className="nav nav-tabs" role="tablist">
                    {titoliTab}
                </ul>
                <div className="tab-content">
                    {contenuto}
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Contesto.tsx